import { EXERCISE_VESSEL_ROLES } from '../data/realisticExerciseScenarioData';

/**
 * Canonical form for matching API `unique_identifier` to EXERCISE_VESSEL_ROLES keys (lowercase UUID).
 */
export function normalizeExerciseVesselApiId(raw) {
  if (raw == null) return null;
  let s = String(raw).trim().toLowerCase();
  if (!s) return null;
  s = s.replace(/[\u2010-\u2015\u2212]/g, '-');
  return s;
}

/**
 * Maps live API `unique_identifier` → key in EXERCISE_VESSEL_ROLES (when the pipeline
 * issues new UUIDs but styling/labels stay the same).
 *
 * Example: {"new-threat-uuid-from-bq":"29342b10-ae83-43ab-95ce-979d89b63f73"}
 */
let forwardAliases = null;

function getForwardAliases() {
  if (forwardAliases !== null) return forwardAliases;
  try {
    const raw = process.env.REACT_APP_EXERCISE_VESSEL_ROLE_ALIAS_JSON;
    const parsed = raw ? JSON.parse(raw) : {};
    const obj = typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed) ? parsed : {};
    const norm = {};
    for (const [k, v] of Object.entries(obj)) {
      const nk = normalizeExerciseVesselApiId(k);
      if (!nk) continue;
      norm[nk] = typeof v === 'string' ? normalizeExerciseVesselApiId(v) || v : v;
    }
    forwardAliases = norm;
  } catch {
    forwardAliases = {};
  }
  return forwardAliases;
}

/**
 * Role table key used for EXERCISE_VESSEL_ROLES[...] (may differ from API id when aliased).
 */
export function resolveExerciseRoleKey(apiVesselId) {
  const id = normalizeExerciseVesselApiId(apiVesselId);
  if (!id) return null;
  const aliases = getForwardAliases();
  return aliases[id] || id;
}

export function getExerciseRoleMetaForApiId(apiVesselId) {
  const key = resolveExerciseRoleKey(apiVesselId);
  if (!key) return undefined;
  return EXERCISE_VESSEL_ROLES[key];
}

export function isKnownExerciseVesselApiId(apiVesselId) {
  return getExerciseRoleMetaForApiId(apiVesselId) != null;
}

/**
 * UUID to pass into rawData filters for comms / positions: live id if remapped, else role key.
 */
export function resolveLiveExerciseVesselUuid(roleKeyFromConfig) {
  if (roleKeyFromConfig == null) return null;
  const want = normalizeExerciseVesselApiId(roleKeyFromConfig);
  if (!want) return null;
  const forward = getForwardAliases();
  for (const [live, rk] of Object.entries(forward)) {
    const rkn = typeof rk === 'string' ? normalizeExerciseVesselApiId(rk) : rk;
    if (String(rkn) === want) return String(live);
  }
  return want;
}
